
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seasonal",
      function () {
        return require("private-next-pages/seasonal/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seasonal"])
      });
    }
  